import script from "./HierarchiesSample.vue?vue&type=script&setup=true&lang=js"
export * from "./HierarchiesSample.vue?vue&type=script&setup=true&lang=js"

import "./HierarchiesSample.vue?vue&type=style&index=0&id=5c69e093&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c69e093"]])

export default __exports__